(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drawer-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('#NavDrawer .customsirge-drawer__quiz');
  if (!link) return;
  const close = document.querySelector('#NavDrawer .js-drawer-close');
  if (close) close.click();
}, true);
  } catch(e) { console.error(e); }
})();

})();
